import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Flower = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.66 8.76c.439-1.087-.364-2.509-1.21-3.406.328-1.19.371-2.822-.526-3.575-.897-.754-2.497-.43-3.613.098-1.03-.68-2.568-1.226-3.563-.606-.994.62-1.18 2.243-1.023 3.467-.964.769-1.959 2.064-1.676 3.201s1.768 1.816 2.98 2.044c.434 1.155 1.358 2.501 2.527 2.584.828.058 1.62-.531 2.224-1.263 1.22 1.52 2.082 3.127 2.555 4.706C10.612 14.93 9.115 14 6 14c0 4.155 3.042 5.003 5 5.003l3.2.002c0-2.723-.986-5.91-3.29-8.901.783-.247 1.479-.677 1.75-1.344zm-4.377-.22a2.447 2.447 0 1 1-2.591-4.153 2.447 2.447 0 0 1 2.59 4.153zm5.737 3.708c1.083 2.17 1.669 4.453 1.678 6.705C18.996 16.582 19 12.206 19 8.003c0 0-3.67 1.034-4.98 4.245z"
  }));
});
Flower.displayName = 'Flower';
export var FlowerDimensions = {
  height: 20,
  width: 20
};